import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "../../utils/asyncActions";
import {
  ADMIN_SLIDES_ACTION_RESET,
  ADMIN_SLIDES_FAILURE,
  ADMIN_SLIDES_REQUEST,
  ADMIN_SLIDES_RUN_ACTION_REQUEST,
  ADMIN_SLIDES_SUCCESS,
  SET_LAST_ADMIN_SLIDE_VIEWED,
} from "../adminConstants";

type FetchAdminSlidesArgs = Parameters<typeof ApiService.listAdminSlides>[0];
export const fetchAdminSlides = createAsyncSaga(
  ADMIN_SLIDES_REQUEST,
  ADMIN_SLIDES_SUCCESS,
  ADMIN_SLIDES_FAILURE,
  () => "admin/slides",
  ApiService.listAdminSlides
) as AsyncSagaAction<FetchAdminSlidesArgs>;

export const setAdminLastSlideViewed = (payload: number) => {
  return {
    type: SET_LAST_ADMIN_SLIDE_VIEWED,
    payload,
  };
};

export enum slideActions {
  REPROCESS_METADATA = "reprocess_metadata",
  REIMPORT_SLIDES = "reimport_slides",
}
export const runAction = (payload: {
  action: slideActions;
  slides: number[];
}) => {
  return {
    type: ADMIN_SLIDES_RUN_ACTION_REQUEST,
    payload,
  };
};

export const resetAction = () => {
  return {
    type: ADMIN_SLIDES_ACTION_RESET,
  };
};
